import { getEditor } from './registry'
import { EMPTY_FIELD_VALUE, hasFieldValue } from './fieldValue'

/**
 * Rendu d'un champ unique du schéma. Pour les éditeurs en mode `inline`,
 * la cellule rend un input directement contre lequel l'utilisateur tape ;
 * pour ceux en mode `modal`, on rend la cellule preview (clic ouvre la
 * pop-in ancrée via `onOpenModal`).
 */
export const FieldRow = ({ field, value, onChange, onOpenModal }) => {
  const typeKey = field.type || field.editorType
  const plug = getEditor(typeKey)
  if (!plug) {
    return (
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1.5">
          {field.label || field.key}
        </label>
        <p className="text-xs text-red-600">Type d'éditeur inconnu : « {typeKey} »</p>
      </div>
    )
  }
  const { Cell, mode } = plug

  // Un champ à surface `modal` (image, lien, icône, référence, liste…) n'a
  // AUCUN moyen de se vider : son éditeur ne sait que choisir une valeur. Un
  // champ `inline` s'efface en effaçant son texte — il n'a rien à gagner à un
  // bouton de plus. Un champ requis ne se vide pas : c'est le seul endroit où
  // `required:` veut dire quelque chose dans ce formulaire.
  const canClear = mode !== 'inline' && !field.required && hasFieldValue(value)

  return (
    <div>
      <div className="flex items-baseline justify-between gap-2 mb-1.5">
        <label className="block text-xs font-medium text-gray-500">
          {field.label || field.key}
          {field.required && <span className="text-red-500 ml-1">*</span>}
        </label>
        {canClear && (
          <button
            type="button"
            onClick={() => onChange(EMPTY_FIELD_VALUE)}
            className="text-xs text-gray-500 hover:text-red-600 transition-colors"
          >
            Vider<span className="sr-only"> le champ {field.label || field.key}</span>
          </button>
        )}
      </div>
      {(() => {
        const { key: _ignored, ...config } = field
        if (mode === 'inline' && Cell) {
          return (
            <Cell
              value={value}
              onChange={onChange}
              placeholder={field.placeholder ?? ''}
              {...config}
            />
          )
        }
        // Modal cell (preview button) — or fallback to a basic preview.
        if (Cell) {
          return <Cell value={value} onClick={onOpenModal} {...config} />
        }
        return (
          <button
            type="button"
            onClick={onOpenModal}
            className="px-3 py-2 text-sm border border-gray-200 rounded-lg hover:border-teal-400 text-gray-600 text-left w-full"
          >
            {value ? '✓ défini' : 'Éditer…'}
          </button>
        )
      })()}
      {field.description && (
        <p className="text-xs text-gray-400 mt-1">{field.description}</p>
      )}
    </div>
  )
}
